import React from 'react';

export default function AboutMe() {
  return (
    <div className="resume-about-me">
      <h1>About Me</h1>
      <p>
        I have 5 years of extensive technical experience in front end web
        development. I'm located in San Francisco bay area. After finishing my
        master program in 2015, I started my career as a Front End Developer
        software engineer in Centrify Corporation. I'm passionate about
        Javascript, single page web app, building great user experiences.
      </p>
    </div>
  );
}
